import { useMutation, useQueryClient } from "@tanstack/react-query";
import { API, fetcher } from "@/shared/core-configs";
import { GET_VOUCHERS_KEY } from "./useGetVouchers";

export type BulkValidateResult = {
  validated: string[];
  skipped: string[];
  failed: { id: string; code?: string; error: string }[];
};

export const bulkValidateVouchers = async ({
  ids,
  emails,
}: {
  ids: string[];
  emails: string[];
}): Promise<BulkValidateResult> => {
  const res = await fetcher.post(
    `${API.GESLUB_SERVICE}/voucher/bulk/validate`,
    { ids, emails },
  );
  return res.data;
};

export const useBulkValidateVouchers = () => {
  const queryClient = useQueryClient();

  const { mutateAsync, isPending } = useMutation({
    mutationFn: bulkValidateVouchers,
    onSettled: async () => {
      await queryClient.invalidateQueries({ queryKey: [GET_VOUCHERS_KEY] });
    },
  });

  return { bulkValidateVouchers: mutateAsync, isPending };
};
